//For browser entry
var Fly= require("./dist/npm/fly")
var fly= new Fly;
module.exports = fly;



//////////////////
// WEBPACK FOOTER
// ./node_modules/flyio/index.js
// module id = 211
// module chunks = 0